import React, { useState, useEffect } from 'react';
import profileBanner from '../../Assets/images/profile-bnr.webp'
import { Link, useParams } from "react-router-dom";
import ProImg from "../../Assets/images/listing-bnr.webp"
import ProImg2 from "../../Assets/images/main-banner.webp"
import ProImg3 from "../../Assets/images/pro-img.png"

import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import OwlCarousel from 'react-owl-carousel';
import useMakeRequest from '../../utils/ApiHelper';
import { decodeID } from '../../utils/Helper';
import { ApiConstants } from '../../constants/ApiConstants';
import FrontLoader from '../layout/FrontLoader';


const optionsMain = {
    items: 1,
    loop: true,
    margin: 10,
    nav: true,
    dots: false,
    // responsiveRefreshRate: 200,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
};

const optionsThumb = {
    items: 4,
    loop: true,
    margin: 20,
    nav: false,
    dots: false,
    // center: true,
    // responsiveRefreshRate: 100,
    autoplay: false,
    responsive: {
        0: {
            items: 2,
            margin: 20,
        },
        380: {
            items: 3,
        },
        576: {
            items: 4,
            margin: 30,
        },
    }
};


const ProductDetails = () => {
    const { id } = useParams()
    const productDetail = useMakeRequest()
    const [mainIndex, setMainIndex] = useState(0);
    const [thumbIndex, setThumbIndex] = useState(0);
    const [images, setImages] = useState<any>([])

    const handleMainTranslated = (event: { item: { index: any; }; }) => {
        const newIndex = event.item.index;
        setThumbIndex(1);
    };

    const handleThumbTranslated = (event: { item: { index: any; }; }) => {
        const newIndex = event.item.index;
        setMainIndex(newIndex);
    };

    useEffect(() => {
        // Sync main slider when thumbIndex changes
        if (mainIndex !== thumbIndex) {
            setMainIndex(thumbIndex);
        }
    }, [thumbIndex]);

    useEffect(() => {
        // Sync thumb slider when mainIndex changes
        if (mainIndex !== thumbIndex) {
            setThumbIndex(mainIndex);
        }
    }, [mainIndex]);

    useEffect(() => {
        if (decodeID(id)) {
            const payload = {
                detail_id: decodeID(id)
            }
            productDetail.makeRequest({ payload, url: ApiConstants?.Prodcutdetails, toastStatus: false })
        }
    }, [])
    useEffect(() => {
        if (productDetail.status) {
            setImages(productDetail?.data?.data?.product_image_detail)
        }
    }, [productDetail.status])

    return (
        <>
        {productDetail.loading ? <FrontLoader/> : null}
            <main>

                {/* top banner section start  */}
                <section className="main-banner small-banner" style={{ background: `url(${profileBanner}) center/cover` }}>
                    <div className="container">
                        <h1 className="small-banner-heading">Product Detail</h1>
                        <nav className="com-breadcrumb" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/product">Product</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Product Detail</li>
                            </ol>
                        </nav>
                    </div>
                </section>
                {/* top banner section end  */}

                <div className="container footer-space">

                    <div className="product-detail-slider">
                        {images.length > 0 ?
                            <>
                                <OwlCarousel
                                    className="owl-theme product-slider-2"
                                    {...optionsMain}
                                    startPosition={mainIndex}
                                    onTranslated={handleMainTranslated}
                                >
                                    {images?.map((resp: any, i: any) => (
                                        <div className="item" key={i}><img className='cover-img' src={resp?.file_path ? resp?.file_path : ProImg} alt="" /></div>
                                    ))}
                                </OwlCarousel>

{images.length > 1 ? 
                                <OwlCarousel
                                    className="owl-theme mt-4 product-slider"
                                    {...optionsThumb}
                                    startPosition={thumbIndex}
                                    onTranslated={handleThumbTranslated}
                                    loop={false}
                                >
                                    {images?.map((resp: any, i: any) => (
                                        <div className="item" key={i}><img className='cover-img' src={resp?.file_path ? resp?.file_path : ProImg} alt="" /></div>
                                    ))}
                                </OwlCarousel>
:null}
                            </>
                            : "Not data"}

                    </div>

                    {/* <div className="section-space">
                <h2 className="title-1">Specifications</h2>
                <div className="row">
                    <div className="col-sm-4 col-md-3">
                        <div className="label-txt">Brand</div>
                        <div className="label-txt">All Brands Available</div>
                    </div>
                    <div className="col-sm-4 col-md-3">
                        <div className="label-txt">Part Number</div>
                        <div className="label-txt">KJJ4540</div>
                    </div>
                    <div className="col-sm-4 col-md-3">
                        <div className="label-txt">Quantity</div>
                        <div className="label-txt">50pcs</div>
                    </div>
                    <div className="col-sm-4 col-md-3">
                        <div className="label-txt">Serial Number</div>
                        <div className="label-txt">KJJ4540</div>
                    </div>
                </div>
            </div> */}


                    <div>
                        <h2 className="title-1">Description</h2>
                        <p>{productDetail?.data?.data?.product_details?.description}</p>
                    </div>
                </div>


            </main>
        </>
    )
}


export default ProductDetails;